$(function () {
    $('[data-toggle="popover"]').popover();

    //select2
    $('.customSelect').select2({
        width: '100%'
    });

	$('.obce_autocomplete').autocomplete({
		minLength: 3,
		source: BASE_URL + 'admin/subjekty/city-ajax',
		focus: function (event, ui) {
			return false;
		},
		select: function (event, ui) {
			$('#frmkontaktForm-adresa_psc').val(ui.item.psc);
			$('#frmkontaktForm-adresa_mesto').val(ui.item.nazev);
			return false;
		}
	});

});


